<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Marketing - Products</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Products</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">TBA</h4>
            <p>The table below shows the list of TBA products.</p>
            <div class="table-responsive">
              <table id="products_tba_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Brochure Link</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in products_tba" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.name }}</td>
                    <td>{{ product.description }}</td>
                    <td>
                      <button class="btn btn-primary" @click="
                        downloadBrochure(product.id, product.brochure_link)
                        ">
                        Download Brochure
                      </button>
                    </td>

                    <td>
                      <router-link :to="productDetail(product.id)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">
                        Edit Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- TBK -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">TBK</h4>
            <p>The table below shows the list of TBK products.</p>
            <div class="table-responsive">
              <table id="products_tbk_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Brochure Link</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in products_tbk" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.name }}</td>
                    <td>{{ product.description }}</td>
                    <td>
                      <button class="btn btn-primary" @click="
                        downloadBrochure(product.id, product.brochure_link)
                        ">
                        Download Brochure
                      </button>
                    </td>

                    <td>
                      <router-link :to="productDetail(product.id, product.name)" type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;">
                        Edit Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "marketing",
  components: {},

  data() {
    return {
      y: "",
      products_tba: [
        {
          name: "",
          description: ""
        }
      ],
      products_tbk: [
        {
          name: "",
          description: ""
        }
      ],

      user: JSON.parse(localStorage.getItem("user"))
    };
  },

  methods: {
    loadProductsTBA() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/products/type/1", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.products_tba = res.data;
            var y = "";
            for (let i = 0; i < res.data.length; i++) { }
          });
      }
    },

    loadProductsTBK() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/products/type/2", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.products_tbk = res.data;
          });
      }
    },

    productDetail(id, name) {
      return "/marketing/product/detail/" + id;
    },

    downloadBrochure(id, link) {
      let token = localStorage.getItem("token");

      if (link !== null) {
        let arrLink = link.split("/");

        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/products/" + id + "/download/brochure", {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.brochure = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[2]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }
    }
  },

  mounted() {
    this.loadProductsTBA();
    this.loadProductsTBK();

    setTimeout(function () {
      $("#products_tba_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2]
            }
          }
        ]
      });

      $("#products_tbk_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2]
            }
          }
        ]
      });
    }, 1000);
  }
};
</script>
